<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />

    <example-title src="example-1.html" title="Normal buttons" />

    <vc-layout :spacing="8">
      <vc-col :span="12" sm24>
        <vc-button-group color="primary" v-model="normal3" @input="input($event)">
          <vc-button :name="button" v-for="(button, index) in normalButtons" :key="index">
            {{ button }}
          </vc-button>
        </vc-button-group>
        <div :class="['mt-16']">
          <code>v-model: {{ normal3 }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" sm24>
        <vc-button-group color="primary" size="large" v-model="normal4" @input="input($event)">
          <vc-button :name="button" v-for="(button, index) in normalButtons" :key="index">
            {{ button }}
          </vc-button>
        </vc-button-group>
        <div :class="['mt-16']">
          <code>v-model: {{ normal4 }}</code>
        </div>
      </vc-col>
    </vc-layout>

    <example-title src="example-2.html" title="Normal buttons with icons" />

    <vc-layout :spacing="8">
      <vc-col :span="12" sm24>
        <vc-button-group color="deep-purple" v-model="normal1" @input="input($event)">
          <vc-button :icon-left="`content_${button}`" :name="button" v-for="(button, index) in normalButtons" :key="index">
            {{ button }}
          </vc-button>
        </vc-button-group>
        <div :class="['mt-16']">
          <code>v-model: {{ normal1 }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" sm24>
        <vc-button-group color="green" v-model="normal2" @input="input($event)">
          <vc-button :name="button" v-for="(button, index) in normalButtons" :key="index">
            <vc-icon>{{ `content_${button}` }}</vc-icon>
          </vc-button>
        </vc-button-group>
        <div :class="['mt-16']">
          <code>v-model: {{ normal2 }}</code>
        </div>
      </vc-col>
    </vc-layout>

    <example-title src="example-3.html" title="Exclusive buttons" />

    <vc-layout :spacing="8">
      <vc-col :span="12" sm24>
        <vc-button-group size="small" type="exclusive" color="teal" v-model="exclusive1" @input="input($event)">
          <vc-button :icon-left="`format_align_${button}`" :name="button" v-for="(button, index) in exclusiveButtons" :key="index">
            {{ button }}
          </vc-button>
        </vc-button-group>
        <div :class="['mt-16']">
          <code>v-model: {{ exclusive1 }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" sm24>
        <vc-button-group type="exclusive" color="pink" v-model="exclusive2" @input="input($event)">
          <vc-button :name="button" v-for="(button, index) in exclusiveButtons" :key="index">
            <vc-icon>{{ `format_align_${button}` }}</vc-icon>
          </vc-button>
        </vc-button-group>
        <div :class="['mt-16']">
          <code>v-model: {{ exclusive2 }}</code>
        </div>
      </vc-col>
    </vc-layout>

    <example-title src="example-4.html" title="Toggle Buttons" />

    <vc-layout :spacing="8">
      <vc-col :span="12" sm24>
        <vc-button-group type="toggle" color="red" @input="input($event)" v-model="toggle1">
          <vc-button :icon-left="`format_${button}`" :name="button" v-for="(button, index) in toggleButtons" :key="index">
            {{ button }}
          </vc-button>
        </vc-button-group>
        <div :class="['mt-16']">
          <code>v-model: {{ toggle1 }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" sm24>
        <vc-button-group size="large" type="toggle" color="orange" @input="input($event)" v-model="toggle2">
          <vc-button :name="button" v-for="(button, index) in toggleButtons" :key="index">
            <vc-icon>{{ `format_${button}` }}</vc-icon>
          </vc-button>
        </vc-button-group>
        <div :class="['mt-16']">
          <code>v-model: {{ toggle2 }}</code>
        </div>
      </vc-col>
    </vc-layout>

    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'ButtonGroupPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      normal1: [],
      normal2: [],
      normal3: [],
      normal4: [],
      exclusive1: ['center'],
      exclusive2: [],
      toggle1: ['bold', 'italic'],
      toggle2: [],
      normalButtons: ['cut', 'copy', 'paste'],
      exclusiveButtons: ['left', 'center', 'right', 'justify'],
      toggleButtons: ['bold', 'italic', 'underline', 'strikethrough']
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    input (event) {
      console.log('vc-button-group:input', event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/button-group.vue